<template>
  <v-container fluid class="systemsetting-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/systemsetting/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="systemsettings-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="headers"
              :items="settings"

              :items-per-page="systemsettingPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="dialog"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this SystemSetting?
                    </v-card-title>
                    <v-card-text>
                      {{ deletesystemsetting.settingcode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="dialog = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteSystemSetting(deletesystemsetting)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.systemsettingstatus="{ item }">
                <v-chip
                  :color="!item.systemsettingstatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.systemsettingstatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editSystemSetting(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'SystemSettingList',
  data() {
    return {
      dialog: false,
      deletesystemsetting: {},
      headers: [
        { text: 'Code', value: 'settingcode'},
        { text: 'Name', value: 'settingname'},
        { text: 'Type', value: 'settingtype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Update', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      systemsettingPerPage: 100,
      selected: [],      
    }
  },
  computed: {
    ...mapState('SystemSetting', ['settings', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
    formTitle () {
      return this.editedIndex === -1 ? 'New SystemSetting' : 'Edit SystemSetting'
    },
  },
  created () {
    this.getSystemSettingsRequest()
  },

  methods: {
    ...mapActions('SystemSetting', [
      "createSystemSettingRequest",
      "deleteSystemSettingRequest",
      "getSystemSettingsRequest",
      "updateSystemSettingRequest",
    ]),
    editSystemSetting(item) {
      this.$router.push({ name: 'SystemSettingEdit', params: item })
    },
    deleteSystemSetting(item) {
      this.deleteSystemSettingRequest({_id: item._id});
      this.dialog = false;
    },
    deleteDialog(item) {
      this.dialog = true;
      this.deletesystemsetting = {
        _id: item._id,
        systemsettingcode: item.systemsettingcode,
      }
    },

  },
}
</script>

<style src="./List.scss" lang="scss"></style>
